import { render } from "./dialogAyudaCreacionOficios.vue?vue&type=template&id=1d8fca03&scoped=true"
import script from "./dialogAyudaCreacionOficios.vue?vue&type=script&lang=js"
export * from "./dialogAyudaCreacionOficios.vue?vue&type=script&lang=js"

import "./dialogAyudaCreacionOficios.vue?vue&type=style&index=0&id=1d8fca03&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8fca03"]])

export default __exports__